<template>
  <div :id="'cont_' + formProperty.nativename" :class="getCompCSS(volatile)">
    <q-input :label="getTitle()" filled v-model="model" :hint="getHint()" hide-hint :maxlength="getMaxlength()"
             :autofocus="formProperty.autofocus" :readonly="formProperty.readonly || readOnly" debounce="1500" :dense="volatile || compressed"
             :filled="true" :class="formProperty.cssClass"
             :error="(v$.value.$error && !v$.$errors.map(err => err.$validator).includes('requiredIf')) || formProperty.invalid" :error-message="getErrorLabel()"
             @update:model-value="onChange" :placeholder="formProperty.infoTextHint"
             :id="formProperty.nativename" :ref="formProperty.nativename" clearable>

      <template #append>
        <q-icon name="event" class="cursor-pointer" v-if="!isTime() && !(formProperty.readonly || readOnly)">
          <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
            <!-- <q-date v-model="model" @input="()=>{$refs.qDateProxy.hide(); onChange()}" :mask="getMask()"/> -->
            <div style="width:300px;">
              <div class="row q-pa-sm bg-primary text-white">
                <div class="col-8 row justify-evenly items-center">
                  <q-icon name="fas fa-chevron-left" @click="calendarPrev"/>
                  <div class="text-center text-bold" style="min-width: 100px;">{{ getFormattedMonth() }}</div>
                  <q-icon name="fas fa-chevron-right" @click="calendarNext"/>
                </div>
                <div class="col-4 row justify-evenly items-center">
                  <q-icon name="fas fa-chevron-left" @click="addToYear(-1)"/>
                  <span class="text-bold">{{ selectedYear }}</span>
                  <q-icon name="fas fa-chevron-right" @click="addToYear(1)"/>
                </div>
              </div>
              <q-calendar-month
                :ref="formProperty.nativename + 'Calendar'"
                v-model="selectedDate"
                :weekdays="[1, 2, 3, 4, 5, 6, 0]"
                locale="de"
                mini-mode
                animated
                show-work-weeks
                @click-date="$refs.qDateProxy.hide(); setModelFromCalendar($event); onChange()"
              />
            </div>
          </q-popup-proxy>
        </q-icon>

        <q-icon name="access_time" class="cursor-pointer" v-if="(isDateTime() || isTime()) && !(formProperty.readonly || readOnly)">
          <q-popup-proxy ref="qTimeProxy" transition-show="scale" transition-hide="scale">
            <q-time v-model="model" @update:model-value="() => {$refs.qTimeProxy.hide(); onChange()}" :mask="getMask()" format24h/>
          </q-popup-proxy>
        </q-icon>

      </template>
    </q-input>

    <!--    <div v-else class="roRow">
          <span class="roLabel" v-html="getTitle() + ':'"></span>
          <span class="roValue" v-html="this.getDateFormatted(model)"></span>
        </div>-->
  </div>
</template>

<script>
import {setCssVar, QDate, QField} from 'quasar'
import useVuelidate from '@vuelidate/core'
import {requiredIf} from '@vuelidate/validators'
import moment from 'moment'
import {fldComponentsMixin} from './mixins/fldComponent'
import {StaticData} from '../../classes/StaticData'

import Timestamp from '@quasar/quasar-ui-qcalendar/Timestamp'
// import QCalendarMonth from '@quasar/quasar-ui-qcalendar/QCalendarMonth'
/*
import QCalendarMonth from '@quasar/quasar-ui-qcalendar'
import '@quasar/quasar-ui-qcalendar/index.css'

import '@quasar/quasar-ui-qcalendar/src/QCalendarVariables.scss'
import '@quasar/quasar-ui-qcalendar/src/QCalendarTransitions.scss'
import '@quasar/quasar-ui-qcalendar/src/QCalendar.scss'
*/

import {useAuthStore} from 'src/stores/AuthStore.js'

export default {
  mixins: [fldComponentsMixin],
  props: [
    'queryID',
    'formProperty',
    'volatile',
    'compressed',
    'readOnly'
  ],
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    return {
      StaticData,
      model: this.getModel(),   // default format: DD.MM.YYYY (getMask())
      value: "",                 // default format: YYYY/MM/DD HH:mm:SS
      //q-calendar data
      selectedDate: Timestamp.parseDate(moment().toDate()).date,
      selectedYear: new Date().getFullYear(),
    }
  },
  validations() {
    return this.getValidations()
  },
  components: {
    QField,
    QDate,
    // QCalendarMonth
  },
  watch: {
    model: function () {
      // get model from q-date in mask format DD.MM.YYYY
      this.setFormattedValue(this.model)
    },
    formProperty: {
      handler: function (newVal) {
        this.model = this.getDateFormatted(newVal.value)
        this.value = newVal.value
        this.formProperty.value = newVal.value
      },
      deep: false
    },
    selectedDate() {
      if (this.selectedDate) {
        const tm = Timestamp.parseTimestamp(this.selectedDate)
        this.selectedYear = tm.year
      }
    }
  },
  computed: {},
  methods: {
    getMask() {
      let format = ""
      switch (this.formProperty.dataTypeID) {
        case StaticData.DATATYPES.TYPE_DATE:
          format = "DD.MM.YYYY";
          break;
        case StaticData.DATATYPES.TYPE_TIME:
          format = "HH:mm";
          break;
        case StaticData.DATATYPES.TYPE_DATETIME:
          format = "DD.MM.YYYY HH:mm";
          break;
      }
      return format
    },
    isDateTime() {
      return this.formProperty.dataTypeID == StaticData.DATATYPES.TYPE_DATETIME
    },
    isDate() {
      return this.formProperty.dataTypeID == StaticData.DATATYPES.TYPE_DATE
    },
    isTime() {
      return this.formProperty.dataTypeID == StaticData.DATATYPES.TYPE_TIME
    },
    getMaxlength() {
      return this.formProperty.dataTypeID == StaticData.DATATYPES.TYPE_DATE ? 10 : 16
    },
    formatDate(sDate, format) {
      let result = moment(sDate, "DD.MM.YYYY HH:mm:ss").format(format)
      return result;
    },
    setFormattedValue(pval) {
      if (pval && pval.trim() != "") {
        if (!moment(pval, "YYYY/MM/DD HH:mm:ss", true).isValid() && !this.isTime()) {
          if (moment(pval, "DD.MM.YYYY HH:mm:ss").isValid()) {
            this.value = moment(pval, "DD.MM.YYYY HH:mm:ss").format("YYYY/MM/DD HH:mm:ss")
          } else {
            this.value = ""
            this.formProperty.value = this.value
            this.model = ""
          }
        } else {
          this.value = pval
        }
        this.formProperty.value = this.value
      } else if (pval == null || pval == "") {
        this.value = ""
        this.formProperty.value = this.value
        this.model = ""
      }
    },
    onChange() {
      if (this.model && this.model != "") {
        if (moment(this.model, this.getMask()).isValid()) {
          this.selectedDate = Timestamp.parseDate(moment(this.model, this.getMask()).toDate()).date
        }
      }
      this.formProperty.invalid = false
      this.v$.$touch()
      this.setErrorBrandColor()

      this.setFormattedValue(this.model)
      // console.warn("onChange value is:", this.model, "==", this.value)

      // todo: only in formulars
      this.$emit('onChange', {
        classID: this.formProperty.classID,
        nativename: this.formProperty.nativename, deleteDependentFields: false, value: this.value
      })  // send onChange event to parent (formular or parameter)
      if (this.$route.name === StaticData.ROUTE_NAMES.FORMULAR) {
        this.eventBus.formularEdited()
      }
    },

    getModel() {
      const authStore = useAuthStore()
      // value from formProperty (can have one initialized from last rendering or it's value
      let result = typeof this.formProperty.value !== "undefined" ? this.formProperty.value : ""
      let propertyName = this.formProperty.name ? this.formProperty.name : this.formProperty.nativename
      let storedValue = localStorage.getItem(this.queryID + "__" + propertyName)
      let deepLinkParamValue = authStore.queryParamListFromDeepLink[this.formProperty.nativename]

      if (deepLinkParamValue) {
        deepLinkParamValue += " 00:00:00"
        result = this.getDateFormatted(deepLinkParamValue)
        this.formProperty.value = deepLinkParamValue

      } else if (storedValue != null && !this.formProperty.systemParameter) {
        // use stored value in localstorage
        result = this.getDateFormatted(storedValue)
        this.formProperty.value = storedValue
      } else if (result != null && result != "") {
        result = this.getDateFormatted(result)
        //console.warn("value result for ", this.formProperty.title, result)

      } else {
        if (this.formProperty.defaultValue) {
          // no own value, no stored value from last call - use defaultvalue
          result = this.getDateFormatted(this.formProperty.defaultValue)
          this.formProperty.value = this.formProperty.defaultValue
          //console.warn("defaultValue result for ", this.formProperty.title, result)
        }
      }
      return result
    },
    getDateFormatted(strDate) {
      if (strDate) {
        if (this.isDateTime() || this.isDate()) {
          if (strDate.length > 10) {
            return moment(strDate, ["YYYY/MM/DD HH:mm:ss", "DD.MM.YYYY HH:mm:ss", "YYYY-MM-DD HH:mm:ss"]).format(this.getMask())
          } else {
            return moment(strDate, ["YYYY/MM/DD", "DD.MM.YYYY", "YYYY-MM-DD HH:mm:ss"]).format(this.getMask())
          }
        } else {
          return strDate  // time format - no need to reformat
        }
      } else {
        return this.value
      }
    },
    getErrorLabel() {
      let result = this.formProperty.errorMsg
      const errors = this.v$.$errors.map(err => err.$validator)
      if (errors.includes("isDate")) {
        result = "Ungültiges Datum."

      } else if (errors.includes("pastDateRestriction")) {
        result = "Datum muss heute oder in der Vergangenheit sein"

      } else if (errors.includes("futureDateRestriction")) {
        result = "Datum muss in der Zukunft sein"

      } else if (errors.includes("requiredIf")) {
        if (this.formProperty.paramInfoRequired != null && this.formProperty.paramInfoRequired != "") {
          result = this.formProperty.paramInfoRequired
        } else {
          result = "Feld muss befüllt werden."
        }
      } else if (errors.includes("isValidGen")) {
        result = this.formProperty.errorMsg
        if (result == "") result = "Fehler bei Feldkonfiguration"
      }
      return result
    },
    getValidations() {
      let result = {value: {}}

      result.value['requiredIf'] = requiredIf(() => {
        if (this.formProperty.masterPropertyMode == StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE) {
          return (this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.LAZY) &&
            this.formProperty.showThroughDependency == true
        } else {
          return this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.LAZY
        }
      })

      result.value['isDate'] = function (value, vueinstance) {

        if (vueinstance.model) {
          let mydate = moment(vueinstance.model, vueinstance.getMask())
          return mydate.isValid()
        } else {
          return true
        }
      }

      result.value['pastDateRestriction'] = function (value, vueinstance) {
        if (vueinstance.model && vueinstance.formProperty.dateRestriction == 1) {
          let mydate = moment(vueinstance.model, vueinstance.getMask())
          if (mydate.isBefore(new Date()) || mydate.isSame(new Date())) return true
          return false
        } else {
          return true
        }
      }


      result.value['futureDateRestriction'] = function (value, vueinstance) {
        if (vueinstance.model && vueinstance.formProperty.dateRestriction == 2) {
          let mydate = moment(vueinstance.model, vueinstance.getMask())
          if (mydate.isAfter(new Date())) return true
          return false
        } else {
          return true
        }
      }

      result.value['isValidGen'] = () => {  // generell invalid flag (triggered from extern)
        if (typeof this.formProperty.invalid === "undefined") return true;
        return !this.formProperty.invalid
      }
      return result;
    },

    setErrorBrandColor() {
      try {
        if (this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.LAZY) {
          setCssVar('negative', '#f57c00', document.getElementById('cont_' + this.formProperty.nativename))
        } else {
          setCssVar('negative', '#c10015', document.getElementById('cont_' + this.formProperty.nativename))
        }
      } catch (e) {
      }
    },

    //q-calendar methods
    addToYear(amount) {
      let ts = Timestamp.parseTimestamp(this.selectedDate)
      ts = Timestamp.addToDate(ts, {year: amount})
      this.selectedDate = ts.date
      this.selectedYear = ts.year
    },

    calendarNext() {
      this.$refs[this.formProperty.nativename + 'Calendar'].next()
    },

    calendarPrev() {
      this.$refs[this.formProperty.nativename + 'Calendar'].prev()
    },

    getFormattedMonth() {
      return new Date(this.selectedDate).toLocaleString('default', {month: 'long'})
    },

    setModelFromCalendar(e) {
      let newMom = moment(e.scope.timestamp.date)
      if (this.model) {
        let oldMom = moment(this.model, this.getMask())
        newMom.set({
          hour: oldMom.get('hour'),
          minute: oldMom.get('minute'),
          second: oldMom.get('second')
        });
      } else {
        newMom.set({hour: 0})
      }
      this.model = newMom.format(this.getMask())
    },

    onRefreshComp(data) {
      if (this.formProperty.nativename === data.nativename && (typeof data.subtypeCount === undefined || data.subtypeCount === this.formProperty.subtypeCount)) {
        // only refresh if we have data and it is not a staticTextField without SQL (which never can change)
        if (data.value !== undefined && data.value != null) {

          //console.log("Date:", this.formProperty.nativename, data.value, this.formProperty.fieldDependencies)

          let myDepToken = this.formProperty.fieldDependencies ? this.formProperty.fieldDependencies.split(";") : ''
          // this component instance is a dependent field of changed field?
          if (myDepToken.includes(data.sourceChangedNativename)) {
            //console.log(this.formProperty.nativename, " value:", data.value)

            if (!data.value) this.model = ""
            else this.model = this.getDateFormatted(data.value)
            this.value = data.value
            this.formProperty.value = data.value

            if (data.errorMsg) this.formProperty.errorMsg = data.errorMsg
            else this.formProperty.errorMsg = ""
            if (data.errorFetchingData) this.formProperty.errorFetchingData = data.errorFetchingData
            else this.formProperty.errorFetchingData = ""

            if (data.errorMsg || data.errorFetchingData) this.formProperty.invalid = true
            else this.formProperty.invalid = false

            this.$forceUpdate()
            if (this.formProperty.instantRefresh &&
              //(this.formProperty.renderOnFrontend && (this.formProperty.showThroughDependency == true || this.formProperty.masterPropertyMode != StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE))) {
              (this.formProperty.showThroughDependency === true || this.formProperty.masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE)) {
              //console.log("cascade onChange ongoing from ", this.frmProperty.title)
              //console.log("emit onchange for ", this.formProperty.nativename)
              this.$emit('onChange', {
                classID: this.formProperty.classID,
                id: this.formProperty.ID,
                nativename: this.formProperty.nativename, deleteDependentFields: true, value: this.value
              })  // send onChange event to parent (formular or parameter)

            } else {
              this.showSpinner = false
            }
          }
        }
      }
    },
  },

  beforeUnmount() {
    this.eventBus.off('onRefreshComp', this.onRefreshComp)
  },

  mounted() {
    this.eventBus.on('onRefreshComp', this.onRefreshComp)

    this.formProperty.validate = () => {

      this.setErrorBrandColor()
      if (this.formProperty.errorFetchingData != "null" && this.formProperty.errorFetchingData != "") {
        this.formProperty.errorMsg = this.formProperty.errorFetchingData
        this.formProperty.invalid = true
        this.v$.$reset()
        this.v$.$touch()
        //console.warn("errorFetchingData ", this.formProperty.title, ":", this.formProperty.errorMsg, ", invalid: ", this.v$.model.$error)

      } else {
        this.formProperty.invalid = false
        this.v$.$reset()
        this.v$.$touch()
        this.formProperty.invalid = this.v$.value.$error
        this.formProperty.errorMsg = this.getErrorLabel()
        //console.warn("validate ", this.formProperty.title, ":", this.formProperty, ", invalid: ", this.v$.model.$error, ", model:", this.model, ", value:", this.value)
      }
    }

    this.formProperty.setValid = () => {
      this.formProperty.errorMsg = ""
      this.formProperty.invalid = false
    }

    this.formProperty.setError = (errMsg) => {
      let tmp = this.model
      this.model = ""
      this.model = tmp // rerender field & errorstats
      this.formProperty.errorMsg = errMsg
      this.formProperty.invalid = true
    }

    this.setFormattedValue(this.model)
    // send onChange event to parent (formular or parameter)
    if (!this.formProperty.noInitOnChange && !this.formProperty.objInstanceID) {
      this.$emit('onChange', {classID: this.formProperty.classID, nativename: this.formProperty.nativename, deleteDependentFields: false, value: this.value})
    }
  }
}
</script>

<style lang="sass">
.q-calendar-weekly__workweek
  color: var(--q-color-primary)
  font-size: 10px !important

  //.q-field--dense .q-field__label
  //  top: 6px

  .q-field--dense
    font-size: 13px

  .q-field--dense .q-field__bottom
    padding-top: 2px
</style>
